import { render } from "./side-nav-menu.vue?vue&type=template&id=2e3b67f0"
import script from "./side-nav-menu.vue?vue&type=script&lang=js"
export * from "./side-nav-menu.vue?vue&type=script&lang=js"

import "./side-nav-menu.vue?vue&type=style&index=0&id=2e3b67f0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__